import { api } from "../../lib";

export interface CptCode {
  id: string;
  code: string;
  description: string;
  isActive: boolean;
  fee: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCptCodeInput {
  code: string;
  description: string;
  isActive?: boolean;
  fee?: number | null;
}

export interface UpdateCptCodeInput extends Partial<CreateCptCodeInput> {
  id: string;
}

export const cptCodesService = {
  getAll: async () => {
    return api.get<CptCode[]>("/admin/cpt-codes");
  },

  getById: async (id: string) => {
    return api.get<CptCode>(`/admin/cpt-codes/${id}`);
  },

  create: async (input: CreateCptCodeInput) => {
    return api.post<CptCode>("/admin/cpt-codes", {
      code: input.code,
      description: input.description,
      isActive: input.isActive ?? true,
      fee: input.fee ?? null,
    });
  },

  update: async (input: UpdateCptCodeInput) => {
    const { id, ...updates } = input;
    return api.put<CptCode>(`/admin/cpt-codes/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/cpt-codes/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<CptCode>(`/admin/cpt-codes/${id}`, {
      isActive,
    });
  },
};
